module.exports = __webpack_public_path__ + "static/media/yoga.dbd4f909.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/yoga.jpg
// module id = 527
// module chunks = 0